var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return [_c('v-card',{staticClass:"pa-6 infographic rounded-lg",class:{hovering: hover},attrs:{"flat":""}},[_c('img',{attrs:{"src":_vm.img}}),_c('h3',{staticClass:"cn-font text-center mb-3 mt-5"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"grey--text text-left"},[_vm._v(_vm._s(_vm.text))])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }